import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import createRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createRecipientWell';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import PeopleIdentity from 'owa-service/lib/contract/PeopleIdentity';

/**
 * Maps people identity objects on an inbox rule to the edit page's recipient well view state, to prepopulate personas
 * @return the RecipientWellWithFindControlViewState populated with the PeopleIdentities as personas
 */
export default function mapPeopleIdentityToRecipientWellWithFindControlViewState(
    peopleIdentity: PeopleIdentity[]
): RecipientWellWithFindControlViewState {
    // map conditional clauses
    let initialMailboxes: EmailAddressWrapper[] = [];

    for (let identity of peopleIdentity) {
        let mailbox: EmailAddressWrapper = {
            Name: identity.DisplayName,
            EmailAddress: identity.SmtpAddress,
            RoutingType: identity.RoutingType,
        };
        initialMailboxes.push(mailbox);
    }
    return createRecipientWell(null, initialMailboxes);
}
